import { useState } from "react";
import { UserWithModuleSettings } from "@models";

export function useSelection(users: UserWithModuleSettings[] | null) {
	const [selection, setSelection] = useState<Record<string, boolean>>({});
	const [isSelectedAll, setSelectedAll] = useState(false);

	const handleSelectAll = (selected: boolean) => {
		setSelectedAll(selected);
		if (users) {
			setSelection(
				users.reduce(
					(prev, curr) => ({
						...prev,
						[curr.userId]: selected,
					}),
					{}
				)
			);
		}
	};

	const selectUser = (user: UserWithModuleSettings, isSelected: boolean) =>
		setSelection({ ...selection, [user.userId]: isSelected });

	const isSelected = (user: UserWithModuleSettings) =>
		selection[user.userId] ?? false;
	const selectedUsers = users?.filter(isSelected) ?? [];

	return {
		isSelected,
		isSelectedAll,
		handleSelectAll,
		selectUser,
		selectedUsers,
	};
}
